import OliverText, { TextType } from "@builder/components/general/OliverText";
import "./style.scss";
import classNames from "classnames";

interface FormInputProps {
    label?: string;
    name: string;
    register: any;
    errors?: Record<string, any>;
    type?: string;
    placeholder?: string;
    validation?: Record<string, any>;
    textarea?: boolean;
}

const FormInput = ({ label, name, register, errors, type = "text", placeholder, validation = {}, textarea }: FormInputProps) => {
    console.log(errors)
    return (
        <label className="form-input-wrapper">
            {label && <OliverText text={label} type={TextType.BODY_4} />}
            {!textarea && <input {...register(name, validation)} type={type} className={classNames("form-input", { ["error"]: !!errors?.[name]?.message })} placeholder={placeholder} />}
            {textarea && <textarea {...register(name, validation)} type={type} className={classNames("form-text-area", { ["error"]: !!errors?.[name]?.message })} placeholder={placeholder} />}
            {errors?.[name] && <div className="form-error">
                <img src="./error2.svg" alt="" />
                <OliverText color="red" type={TextType.DESCRIPTION}>{errors[name].message}</OliverText>
            </div>}
        </label>
    );
};

export default FormInput;
